"use client";

import { c as _c } from "react/compiler-runtime";
import TransferToggle from "@/components/nft-transfer/TransferToggle";
import UserAddressesSelectDropdown from "@/components/user/utils/addresses-select/UserAddressesSelectDropdown";
import { CollectedCollectionType, CollectionSeized, CollectionSort } from "@/entities/IProfile";
import { MEMES_SEASON } from "@/enums";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RefObject, useEffect, useRef, useState } from "react";
import { ProfileCollectedFilters } from "../UserPageCollected";
import { COLLECTED_COLLECTIONS_META } from "./user-page-collected-filters.helpers";
import UserPageCollectedFiltersCollection from "./UserPageCollectedFiltersCollection";
import UserPageCollectedFiltersSeized from "./UserPageCollectedFiltersSeized";
import UserPageCollectedFiltersSortBy from "./UserPageCollectedFiltersSortBy";
import UserPageCollectedFiltersSzn from "./UserPageCollectedFiltersSzn";
export default function UserPageCollectedFilters(t0) {
  const $ = _c(50);
  const {
    profile,
    filters,
    containerRef,
    setCollection,
    setSortBy,
    setSeized,
    setSzn,
    showTransfer
  } = t0;
  const scrollContainerRef = useRef(null);
  const contentContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const container = scrollContainerRef.current;
      if (!container) {
        return;
      }
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = container;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const checkScroll = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const container_0 = scrollContainerRef.current;
      const contentContainer = contentContainerRef.current;
      if (!container_0) {
        return;
      }
      checkScroll();
      container_0.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      const resizeObserver = new ResizeObserver(() => {
        checkScroll();
      });
      resizeObserver.observe(container_0);
      if (contentContainer) {
        resizeObserver.observe(contentContainer);
      }
      return () => {
        container_0.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
        resizeObserver.disconnect();
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const container_1 = scrollContainerRef.current;
      if (!container_1) {
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          checkScroll();
        });
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== filters.collection) {
    t5 = [filters.collection];
    $[4] = filters.collection;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const container_2 = scrollContainerRef.current;
      if (!container_2) {
        return;
      }
      container_2.scrollBy({
        left: -150,
        behavior: "smooth"
      });
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const scrollLeft_0 = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const container_3 = scrollContainerRef.current;
      if (!container_3) {
        return;
      }
      container_3.scrollBy({
        left: 150,
        behavior: "smooth"
      });
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const scrollRight = t7;
  const getShowSeized = _temp;
  const getShowSzn = _temp2;
  let t8;
  if ($[8] !== showTransfer) {
    t8 = showTransfer && <TransferToggle />;
    $[8] = showTransfer;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== filters.collection || $[11] !== setCollection) {
    t9 = <UserPageCollectedFiltersCollection selected={filters.collection} setSelected={setCollection} />;
    $[10] = filters.collection;
    $[11] = setCollection;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== filters.collection || $[14] !== filters.sortBy || $[15] !== filters.sortDirection || $[16] !== setSortBy) {
    t10 = <UserPageCollectedFiltersSortBy selected={filters.sortBy} direction={filters.sortDirection} collection={filters.collection} setSelected={setSortBy} />;
    $[13] = filters.collection;
    $[14] = filters.sortBy;
    $[15] = filters.sortDirection;
    $[16] = setSortBy;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== containerRef || $[19] !== filters.collection || $[20] !== filters.seized || $[21] !== setSeized) {
    t11 = getShowSeized(filters.collection) && <UserPageCollectedFiltersSeized selected={filters.seized} containerRef={containerRef} setSelected={setSeized} />;
    $[18] = containerRef;
    $[19] = filters.collection;
    $[20] = filters.seized;
    $[21] = setSeized;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== containerRef || $[24] !== filters.collection || $[25] !== filters.szn || $[26] !== setSzn) {
    t12 = getShowSzn(filters.collection) && <UserPageCollectedFiltersSzn selected={filters.szn} containerRef={containerRef} setSelected={setSzn} />;
    $[23] = containerRef;
    $[24] = filters.collection;
    $[25] = filters.szn;
    $[26] = setSzn;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t8 || $[32] !== t9) {
    t13 = <div className="tw-flex tw-nowrap tw-gap-x-3 lg:tw-gap-x-4 tw-items-center tw-flex-shrink-0">{t8}{t9}{t10}{t11}{t12}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t8;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== profile.wallets) {
    t14 = profile.wallets ?? [];
    $[34] = profile.wallets;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== containerRef || $[37] !== t14) {
    t15 = <div className="tw-flex-shrink-0"><UserAddressesSelectDropdown wallets={t14} containerRef={containerRef} onActiveAddress={_temp3} /></div>;
    $[36] = containerRef;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t13 || $[40] !== t15) {
    t16 = <div ref={scrollContainerRef} className="tw-w-full tw-overflow-x-auto [&::-webkit-scrollbar]:tw-hidden [-ms-overflow-style:none] [scrollbar-width:none]"><div ref={contentContainerRef} className="tw-flex tw-nowrap tw-justify-between tw-gap-x-3 lg:tw-gap-x-4 tw-items-center tw-w-full tw-min-w-max">{t13}{t15}</div></div>;
    $[39] = t13;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== canScrollLeft) {
    t17 = canScrollLeft && <><div className="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-24 tw-pointer-events-none tw-z-10 tw-bg-gradient-to-r tw-from-black tw-via-black/40 tw-to-black/0" /><button onClick={scrollLeft_0} aria-label="Scroll filters left" className="tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-z-20 tw-inline-flex tw-items-center tw-justify-start tw-group tw-p-0 tw-h-10 tw-w-10 tw-bg-transparent tw-border-none tw-outline-none"><FontAwesomeIcon icon={faChevronLeft} className="tw-h-6 tw-w-6 tw-text-iron-200 group-hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out" /></button></>;
    $[42] = canScrollLeft;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== canScrollRight) {
    t18 = canScrollRight && <><div className="tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-w-24 tw-pointer-events-none tw-z-10 tw-bg-gradient-to-l tw-from-black tw-via-black/40 tw-to-black/0" /><button onClick={scrollRight} aria-label="Scroll filters right" className="tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-z-20 tw-inline-flex tw-items-center tw-justify-end tw-group tw-p-0 tw-h-10 tw-w-10 tw-bg-transparent tw-border-none tw-outline-none"><FontAwesomeIcon icon={faChevronRight} className="tw-h-6 tw-w-6 tw-text-iron-200 group-hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out" /></button></>;
    $[44] = canScrollRight;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t17 || $[48] !== t18) {
    t19 = <div className="tw-relative tw-w-full">{t16}{t17}{t18}</div>;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
}
function _temp3() {}
function _temp2(collection_0) {
  return collection_0 ? COLLECTED_COLLECTIONS_META[collection_0].filters.szn : false;
}
function _temp(collection) {
  return collection ? COLLECTED_COLLECTIONS_META[collection].filters.seized : false;
}